/**
 * Example: 0 to 0, undefined/null to fallback value
 * @param fractionDigits Fraction digits to be processed
 */
export const formatFractionDigits = fractionDigits => {
  const fallbackValue = 2;
  return fractionDigits === null || fractionDigits === undefined
    ? fallbackValue
    : fractionDigits;
};
